module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filters":"filters","show":"Show","hide":"Hide"}}')
  delete Component.options._Ctor
}
